const showRequiredError = container => {
    const checkbox = container.querySelector('input[type=checkbox]');

    checkbox.classList.add('is-invalid');

    if (container.querySelector('.invalid-feedback')) {
        return;
    }

    const feedback = document.createElement('div');
    const message = document.createElement('p');

    feedback.className = 'invalid-feedback';
    message.textContent = container.dataset.requiredCheckbox;
    feedback.append(message);
    checkbox.after(feedback);
};

const clearRequiredError = container => {
    container.querySelector('input[type=checkbox]').classList.remove('is-invalid');
    container.querySelector('.invalid-feedback')?.remove();
};

export const handleRequiredCheckboxSubmit = event => {
    const unchecked = [...event.target.querySelectorAll('[data-required-checkbox]')]
        .filter(container => !container.querySelector('input[type=checkbox]').checked);

    if (unchecked.length === 0) {
        return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();
    unchecked.forEach(showRequiredError);
    unchecked[0].querySelector('input[type=checkbox]').focus();
};

export const handleRequiredCheckboxChange = event => {
    const container = event.target.closest('[data-required-checkbox]');

    if (container && event.target.checked) {
        clearRequiredError(container);
    }
};
